export const ERROR_SCREEN = {
  DESCRIPTION: 'We couldn\'t load your Payment Permissions.',
  BUTTON_TEXT: 'Try again',
  SUPPORT_TEXT: 'Please try again in a few minutes. If the problem continues, ',
  SUPPORT_LINK_TEXT: 'contact Customer Service.',
  SUPPORT_LINK_URL: 'https://www.americanexpress.com/us/customer-service/',
  ARIA_ICON_TITLE: 'Error icon',
};
